import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListCardSkeleton } from '../Common/PageSkeleton';
import userAPI from '../../services/userAPI';
import logo from '../../assets/waseeny-logo.png';
import { useTranslate } from '../../Hook/useTranslate';
import './Profile.css';

const PaymentMethods = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const t = useTranslate();

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const data = await userAPI.getPaymentMethods();
      setPayments(data.cards || []);
    } catch (err) {
      console.error('Failed to fetch payment methods:', err);
    } finally {
      setLoading(false);
    }
  };

  const removeCard = async (card) => {
    if (!window.confirm(`${t("Remove this card?")} •••• ${card.last4}`)) return;
    try {
      const data = await userAPI.removePaymentMethod(card.id);
      setPayments(data.cards || []);
    } catch (err) {
      console.error('Failed to remove card:', err);
    }
  };

  return (
    <div className="profile-container">
      <header className="profile-header" style={{display: 'flex', alignItems: 'center', padding: '10px 20px', gap: '15px', borderBottom: '1px solid #eee'}}>
        <button onClick={() => navigate(-1)} style={{background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M14 5l-6 6 6 6" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <img src={logo} alt="Logo" className="profile-logo" onClick={() => navigate('/home')} style={{height: '35px', cursor: 'pointer'}} />
        <h1 className="profile-title" style={{fontSize: '18px', margin: 0}}>{t("Saved cards")}</h1>
      </header>

      <div className="profile-content">
        <div className="profile-card">
          {loading ? (
            <ListCardSkeleton count={2} />
          ) : payments.length === 0 ? (

            <div className="empty-state">
              <p>{t("No saved cards yet.")}</p>
              <p style={{ color: '#888', fontSize: '14px', marginTop: '10px' }}>
                {t("Tick \"save card\" when you pay by card at checkout. Cards are stored securely by Stripe.")}
              </p>
            </div>
          ) : (
            <div className="payment-list">
              {payments.map((pm) => (
                <div key={pm.id} className="payment-item" style={{
                  padding: '20px',
                  border: '1px solid #eee',
                  borderRadius: '12px',
                  marginBottom: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px'
                }}>
                  <div style={{
                    width: '50px',
                    height: '32px',
                    background: '#f0f0f0',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '10px',
                    fontWeight: 'bold'
                  }}>
                    {(pm.brand || 'card').toUpperCase()}
                  </div>
                  <div style={{ flex: 1 }}>
                    <h3 style={{ margin: '0 0 4px 0', fontSize: '16px' }}>•••• •••• •••• {pm.last4}</h3>
                    <p style={{ margin: '0', color: '#666', fontSize: '14px' }}>{t("Expires")} {String(pm.expMonth).padStart(2, '0')}/{String(pm.expYear).slice(-2)}</p>
                  </div>
                  <button onClick={() => removeCard(pm)} style={{ background: 'none', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer' }}>
                    {t("Remove")}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
